/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import LoadingIn from "../assets/loadingIn.gif";
import  {useCallback, useContext } from 'react'
import downloadMasterIcon from "../assets/icons/download-master.svg";
import closeIcon from "../images/icons/Icon2.png";
import { NGODatePicker } from "./DatePicker";
import LoadingGIF from "../assets/loadingIn.gif";
import Select from "react-select";
import { useEffect, useState } from "react";
import { APIEndpoint } from "../utils/axios";
import moment from "moment";
import {
  calculateTextWidth,
  formatDateByTimezone,
  getCultureFromLs,
} from "../utils/commonFunctions";
import { ToastContainer } from "react-toastify";
import {customSelSearch} from "../utils/configs";
import {ThemeContext} from '../contexts/themeContext';
import checkDownloadStatus from "../utils/checkDownloadStatus";
import useToastAssist from '../utils/useToastAssist';

export const StockMovementVarianceReportDownload = (props) => {
  const [cateringGroupOptions, setCateringGroupOptions] = useState([]);
  const [reportDate, setReportDate] = useState(new Date());
  const [isDownloading, setIsDownloading] = useState(false);
  const [isCatLoading, setIsCatLoading] = useState(false);
  const [selectedCateringGroup, setSelectedCateringGroup] = useState(null);
  const [submissionError, setSubmissionError] = useState(null);
  const [cateringGroupWidth, setCateringGroupWidth] = useState("17rem");
  const {themedColor} = useContext(ThemeContext);
  const {toastError,toastSuccess} = useToastAssist();


const getCustomStyles = (minWidth = "17rem") => {
  
  const baseStyles = customSelSearch({ ...themedColor, hover: themedColor.hover });

  return {
    ...baseStyles,  
    input: (defaultStyles) => ({
      ...defaultStyles,
      color: "#fff",
    }),
    control: (defaultStyles, state) => ({
      ...defaultStyles,
      width: minWidth,
      minWidth: minWidth,
      backgroundColor: themedColor.background,
      cursor: state.isDisabled ? "not-allowed" : "pointer",
    }),
    option: (defaultStyles, state) => ({
      ...baseStyles.option(defaultStyles, state), 
      textAlign: "left",
    }),
    placeholder: (defaultStyles, state) => ({
      ...defaultStyles,
      textAlign: "left",
      color: state.isFocused ? themedColor.hover : "#fff",
    }),
    singleValue: (defaultStyles) => ({
      ...defaultStyles,
      textAlign: "left",
      color: "#fff",
    }),
    indicatorSeparator: (provided) => ({ ...provided, display: "none" }),
  };
};

  useEffect(() => {
    if (cateringGroupOptions.length === 0) {
      setCateringGroupWidth("17rem");
      return;
    }

    const longestLabel = cateringGroupOptions.reduce((max, current) => 
      current.label.length > max.length ? current.label : max, 
      ""
    );

    const calculatedWidth = calculateTextWidth(longestLabel);
    setCateringGroupWidth(`${calculatedWidth + 100}px`);
  }, [cateringGroupOptions]);

  const loadCateringGroupsByDate = useCallback( async (value) => {
    setIsCatLoading(true);
    try {
      const requestPayload = {
        date: formatDateByTimezone(new Date(value ?? new Date()), false),
      };

      /** Get catering groups based on the selected date  */
      const response = await APIEndpoint.post(
        `operations/rotations/find`,
        requestPayload
      );

      let cateringGroupOptns = [];
      response.rotations.forEach((ele) => {
        const dte = moment(ele.legs[0]?.std)
          .tz(getCultureFromLs()?.timezone.name)
          .format("DD-MM-YYYY hh:mm A");
        const cateringGroupLegs = ele.legs.map((leg) => ({
          key: leg.id,
          label: leg.origin,
          value: leg.origin,
          cateringGroup: { id: ele.id, name: ele.name },
          store: {
            flightNumber: leg.flightNumber,
            origin: leg.origin,
            destination: leg.destination,
          },
        }));

        cateringGroupOptns.push({
          key: ele.id,
          label: `${ele.tailNumber}/${ele.flightPath}/${dte}`,
          value: ele.id,
          legs: cateringGroupLegs,
        });
      });

      setCateringGroupOptions(cateringGroupOptns);
    } catch (error) {
      toastError("Failed to load Catering Groups");
    } finally {
      setIsCatLoading(false);
    }
  }
    ,[]) 
   

  useEffect(() => {
    if (!reportDate) return;
    loadCateringGroupsByDate(reportDate);
  }, [reportDate, loadCateringGroupsByDate]);

  const onDateChangeRep = (e) => {
    setSelectedCateringGroup(null);
    setCateringGroupOptions([]);
   
    const { value } = e.target;
    setReportDate(value);
    loadCateringGroupsByDate(value);
  };

  const onCateringGroupChange = (e) => {
    if (!e) {
      setSelectedCateringGroup(null);
     
      return;
    }

    if (e?.label) {
      const newWidth = calculateTextWidth(e.label);
      setCateringGroupWidth(`${newWidth + 100}px`);
    } else {
     
    }

    setSelectedCateringGroup(e);
  };

  const onDownloadSuccess = (resp) => {
    toastSuccess("Stock movement variance report downloaded successfully");
    props.onClose();
  };

  const onDownloadFailure = (error) => {
    props.onClose();
    toastError("Failed to download stock movement variance report");
  };

  const onDownloadClick = async () => {
    if (!selectedCateringGroup?.value) {
      setSubmissionError("Select the catering group!");
      setTimeout(() => {
        setSubmissionError(null);
      }, 3000);
      return;
    }

    const requestPayload = {
      date: formatDateByTimezone(new Date(reportDate), false),
      cateringGroup: {
        id: selectedCateringGroup?.value,
        name: selectedCateringGroup?.label,
      },
      reportType: "stockMovementVarianceReport",
      fileType: "excel",
    };

    let header = {
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };
    try {
      setIsDownloading(true);
      const res = await APIEndpoint.post(
        `sales/reports`,
        requestPayload,
        header
      );
      if (res.status === "scheduled") {
        checkDownloadStatus(res.id, onDownloadSuccess, onDownloadFailure, true);
      }
    } catch (error) {
      toastError("Failed to download stock movement variance report");
    } finally {
      setIsDownloading(false);
    }
  };

  return (<>
      <ToastContainer
          position="top-center"  // Top middle
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
    <div className="overlay" role="dialog">
      <div className="dialog sm-scrollbar">
        <div className="dialog__content">
            <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
          <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50"> Download Stock Movement Variance Report</h2>
              <button className='close-btn-ht' onClick={props.onClose}>
                <img src={closeIcon} alt="close" data-icon='close'/>
              </button>
        </div>
          <hr />

          <div className="dialog__body_container flexRow mt-4 button-align justifyContentCenter flexWrap report-font">
            <div className={`dialog__container_item input-container`}>
              <div className={`dialog__description`}>
                <div className={`flexCol`}>
                  <label className={`textAlignLeft fontRegular req`}>
                    Date
                  </label>
                  <div style={{ position: "relative"}}>
                    <style>{`
                      .react-datepicker__triangle {
                        display: none !important;
                      }
                    `}</style>
                      <NGODatePicker
                      style={{ minWidth: cateringGroupWidth, textAlign: "left", height: "38px", padding: "0.5rem" }}
                      isclearable={true}
                      value={reportDate}
                      placeholder={"Select Date"}
                      placeholdertext={"Select Date"}
                      onChange={onDateChangeRep}
                      className="edit-input-full-width"
                      />
                      </div>
                </div>

                <>
                  <div className="flexCol mb-3">
                    <div className="flexRow justifyContentFlexStart">
                      <label
                        style={{ marginBottom: "0.9rem" }}
                        htmlFor="cateringGroup"
                        className="req textAlignLeft"
                      >
                        Catering Group
                      </label>
                      {isCatLoading ? (
                        <img
                          src={LoadingGIF}
                          style={{ width: "16px", height: "16px" }}
                          alt="Loading"
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <Select
                      inputId="cateringGroup"
                      isClearable
                      isDisabled={false}
                      isSearchable
                      options={cateringGroupOptions}
                      placeholder="Select Catering Group"
                      value={cateringGroupOptions.filter(
                        (cg) => cg.value === selectedCateringGroup?.value
                      )}
                      onChange={onCateringGroupChange}
                      styles={getCustomStyles(cateringGroupWidth)}
                    />
                  </div>
                </>

                <button
                  type="button"
                  onClick={onDownloadClick}
                  className="btn btn-info mt-4"
                  style={{ color: "white", width: "100%" }}
                >
                  {isDownloading ? (
                    <div className="flexRow justifyContentCenter alignItemsCenter">
                      <img
                        src={LoadingIn}
                        style={{
                          marginRight: "5px",
                          width: "25px",
                          height: "25px",
                        }}
                        alt="Loading"
                      />{" "}
                      Processing...
                    </div>
                  ) : (
                    <span>
                      {" "}
                      <img
                        className="icon-size mt-1"
                        alt="downloadMaster"
                        src={downloadMasterIcon}
                      />
                      Download
                    </span>
                  )}
                </button>
              </div>
              {submissionError && (
                <div
                  className="flexRow justifyContentCenter alignItemsCenter textAlignLeft"
                  style={{ marginTop: "1.5rem", width: "100%" }}
                >
                  <p style={{ width: "100%" }} className="listErrorMessagesCls">
                    {submissionError}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};
